<script>
export default {
	props: ['currentZone', 'ProductPage'],
	hookZone: ['after--images', 'bottom-inside', 'after--main-content'],
	showHook(currentZone, ProductPage) {
		return ProductPage.product.info.templateKey == 'descriptionAndAttrs'
	},
	computed: {
		show() {
			if (this.currentZone == 'after--main-content') return false
			return (
				(this.$b.d && this.currentZone == 'after--images') ||
				(this.$b.mt && this.currentZone == 'bottom-inside')
			)
		},
		templateData() {
			return this.ProductPage.product.info.templateData
		},
		attrs() {
			return this.ProductPage.product.attrs || []
		},
	},
}
</script>

<template>
	<div v-if="show" class="mx-n3 px-3" :class="$b.m && 'bordered'">
		<DpcHook :items="ProductPage.hooksData['hooks-product-description-top']" />
		<ProductPage-Description :templateData="templateData" :product="ProductPage.product" class="pa-3" />
		<ProductPage-Attributes :attributes="attrs" class="pa-3" />
		<DpcHook :items="ProductPage.hooksData['hooks-product-description-bottom']" />
		<div v-if="$b.mt && templateData.htmlDescription">
			<div v-html="templateData.htmlDescription" class="pa-3 bordered"></div>
		</div>
	</div>
	<div v-else-if="$b.d && currentZone == 'after--main-content' && templateData.htmlDescription">
		<div v-html="templateData.htmlDescription" class="pa-4 bordered"></div>
	</div>
</template>

<style lang="scss" scoped>
.bordered {
	border-top: 1px solid #eee;
}
</style>

